import {
  InvestmentProductsByTypeParams,
  InvestmentProductsByTypeResponse,
} from '@repo/accounts-types'
import { ApiResponse, Service } from '@repo/core'
import { AxiosRequestConfig } from 'axios'

export const getProductsByType: Service<
  InvestmentProductsByTypeParams,
  ApiResponse<InvestmentProductsByTypeResponse>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, config }) => {
  const { securityAccountId, productType } = params
  return api.get<ApiResponse<InvestmentProductsByTypeResponse>>(
    `/accounts/securities/${securityAccountId}/${productType}`,
    config,
  )
}
